<template>
    <div>
        <div class="com-model">
            <div class="top-bar">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/index/company' }">企业设置</el-breadcrumb-item>
                    <el-breadcrumb-item>{{type === 'default' ? '企业基本信息' : type === 'location' ? '企业位置信息' : ''}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="content" >
                <el-form ref="form" :rules="rules" :model="companyInfo" label-width="80px" v-if="type === 'default'">
                    <el-form-item label="公司简称" prop="shortName">
                        <el-input v-model="companyInfo.shortName"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话" prop="telephone">
                        <el-input v-model="companyInfo.telephone"></el-input>
                    </el-form-item>
                    <el-form-item label="行业类型" prop="industryId">
                        <!-- <el-input v-model="companyInfo.industryId"></el-input> -->
                        <el-select v-model="companyInfo.industryId" placeholder="请选择行业类型">
                            <el-option :label="item.name" :value="item.id" v-for="item in industryList" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="企业规模" prop="scale">
                        <!-- <el-input v-model="companyInfo.scale"></el-input> -->
                        <el-select v-model="companyInfo.scale" placeholder="请选择企业规模">
                            <el-option :label="item" :value="item" v-for="(item, index) in scaleList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工厂简介" prop="description">
                        <el-input type="textarea" v-model="companyInfo.description"></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 60px; margin-bottom: 0; padding-bottom: 60px">
                        <div class="flex flex-center">
                            <div class="primary-border-btn button" type="primary" @click="goBack">取消</div>
                            <div class="primary-btn button" @click="handleSubmit">保存修改</div>
                        </div>
                    </el-form-item>
                </el-form>
                 <el-form ref="form" :rules="rules" :model="companyInfo" label-width="80px" v-else-if="type === 'location'">
                    <el-form-item label="所属区县" >
                        <el-cascader v-model="selectOptions"
                              :options="provinceArr" @active-item-change="handleItemChange"></el-cascader>
                    </el-form-item>
                    <el-form-item label="工厂地址">
                        <el-input class="m-b-14" v-model="companyInfo.address"></el-input>
                        <!--<div class="address-map" style="width: 482px;height: 150px" id="container"></div>-->
                        <TxMap @updateAddress="updateAddress" ref="TxMap" :axis="{lng, lat}" v-if="mapShow"/>
                    </el-form-item>
                    <el-form-item style="margin-top: 60px; margin-bottom: 0; padding-bottom: 60px">
                        <div class="flex flex-center">
                            <div class="primary-border-btn button" type="primary" @click="goBack">取消</div>
                            <div class="primary-btn button" @click="handleSubmit">保存修改</div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import TxMap from '../../components/TxMap.vue';
export default {
    data () {
        return {
            scaleList: ['20人以下', '20-300人', '300-1000人', '1000人以上'],
            companyInfo: {},
            rules: {
                shortName: [
                    { required: true, message: '请输入公司简称', trigger: 'blur' }
                ],
                telephone: [
                    { required: true, message: '请输入公司电话', trigger: 'blur' }
                ],
                industryId: [
                    { required: true, message: '请选择行业类型', trigger: 'blur' }
                ],
                scale: [
                    { required: true, message: '请选择行业类型', trigger: 'blur' }
                ]
            },
            industryList: [],
            type: 'default',
            provinceArr: [],
            selectOptions: [],
            address1: 0, // 地址省份
            address2: 0, // 地址市
            address3: 0, // 地址区县
            lng: "", //经度
            lat: "", // 纬度
            mapShow: false
            // map: null,
            // marker: null,
            // geocoder: null
        }
    },
    components: {
        TxMap
    },
    watch: {
        selectOptions(newval, oldval) {
            if (newval) {
                console.log(newval);
                if (newval.length < 4 || this.provinceIndex == undefined || this.provinceIndex === null) {
                    return
                }
                let self = this;
                const province = this.provinceArr[this.provinceIndex];
                const city = province.children[this.cityIndex];
                const area = city.children[this.areaIndex];
                const stree = area.children.find(item => {
                    return item.id == newval[3];
                })
                const addressName =  province.label + city.label + area.label + stree.label;
                self.lng = '';
                self.lat = '';
                this.$refs.TxMap.addr2latlng(addressName)
                // self.geocoder.getLocation(addressName, function(status, result) {
                //     if (status === "complete" && result.info === "OK") {
                //         self.handleGeocoder(result);
                //     }
                // });
            }
        }
    },
    mounted () {
        this.type = this.$route.query.type || 'default';

        if (this.type === 'default') {
            this.getIndustryList();
        } else if (this.type === 'location') {
            // this.$nextTick(() => {
            //     this.map = new AMap.Map("container", {
            //         zoom: 12,
            //         center: [120.699366, 27.994267],
            //         resizeEnable: false
            //     });
            //     this.geocoder = new AMap.Geocoder({
            //         city: '全国' //城市，默认：“全国”
            //     });
            // });

        }
        this.getInfo();
    },
    methods: {
        getIndustryList () {
            this.axios.get('/wapi/baseData/listIndustry').then(res => {
                if(res.success){
                    this.industryList = res.data;
                }
            })
        },
        getInfo(){
            let url = '/wapi/company/get';
            this.axios.get(url).then(res => {
                if(res.success){
                    const data = res.data
                    this.companyInfo = data;
                    if (this.type === 'location') {
                        this.selectOptions = [
                            data.provinceId,
                            data.cityId,
                            data.areaId,
                            data.streetId
                        ]
                        this.getProvince().then(() => {
                            return this.getCity(data.provinceId);
                        }).then(() => {
                            return this.getArea(data.cityId);
                        }).then(() => {
                            return this.getStreet(data.areaId);
                        })
                        this.lng = data.lng;
                        this.lat = data.lat;
                        this.mapShow = true;
                        // this.$nextTick(() => {
                        //     this.addMarker([data.lng, data.lat])
                        // })
                    }
                }
            })
        },
        goBack () {
            this.$router.go(-1);
        },
        handleSubmit () {
            if (this.type === 'default') {
                this.companyInfo.industryName = this.industryList.find(item => item.id === this.companyInfo.industryId).name;
            }else if (this.type === 'location' && this.selectOptions.length === 4) {
                const province = this.provinceArr[this.provinceIndex];
                const city = province.children[this.cityIndex];
                const area = city.children[this.areaIndex];
                const stree = area.children.find(item => {
                    return item.id == this.selectOptions[3];
                })
                this.companyInfo.provinceId = province.value;
                this.companyInfo.provinceName = province.label;
                this.companyInfo.cityName = city.label;
                this.companyInfo.cityId = city.value;
                this.companyInfo.areaName = area.label;
                this.companyInfo.areaId = area.value;
                this.companyInfo.streetName = stree.label;
                this.companyInfo.streetId = stree.value;
                this.companyInfo.lat = this.lat;
                this.companyInfo.lng = this.lng;
            }
            this.axios.post('/wapi/company/base/modify', this.companyInfo).then(res => {
                if(res.success){
                    this.$message({
                        type:'success',
                        message: '修改成功'
                    });
                    this.$router.go(-1);
                }
            })
        },
        getProvince() {
            return new Promise((resolve, reject) => {
                this.axios.get("/wapi/baseData/listProvince").then(res => {
                    this.provinceArr = res.data.map(item => {
                        item.value = item.id;
                        item.label = item.name;
                        item.children = [];
                        return item;
                    });
                    resolve();
                });
            })
        },
        getCity(id) {
            return new Promise((resolve, reject) => {
                this.axios.get("/wapi/baseData/listCity?provinceId=" + id).then(res => {
                    // this.cityArr = res.data;
                    this.provinceIndex = this.provinceArr.findIndex(item => {
                        return item.id == id;
                    });
                    this.provinceArr[this.provinceIndex].children = res.data.map(
                        (item, index, array) => {
                            item.children = [];
                            item.value = item.id;
                            item.label = item.name;
                            return item;
                        }
                    );
                    resolve()
                });
            })
        },
        getArea(id) {
            return new Promise((resolve, reject) => {
                let xhr = new XMLHttpRequest();
                let url = "/wapi/baseData/listArea?cityId=" + id;
                xhr.open("get", url, false);
                xhr.onload = () => {
                    let json = JSON.parse(xhr.response);
                    // this.areaArr = json.data;
                    this.cityIndex = this.provinceArr[this.provinceIndex].children.findIndex(item => {
                        return item.id == id;
                    });
                    this.provinceArr[this.provinceIndex].children[
                        this.cityIndex
                        ].children = json.data.map(function(item, index, arr) {
                            item.label = item.name;
                            item.value = item.id;
                            item.children = [];
                        return item;
                    });
                    resolve()
                };
                xhr.send();
            })

        },
        getStreet(id) {
            return new Promise((resolve, reject) => {
                let xhr = new XMLHttpRequest();
                let url = "/wapi/baseData/listStreet?areaId=" + id;
                xhr.open("get", url, false);
                xhr.onload = () => {
                    let json = JSON.parse(xhr.response);
                    // this.streetArr = json.data;
                    this.areaIndex = this.provinceArr[this.provinceIndex].children[this.cityIndex].children.findIndex(item => {
                        return item.id == id;
                    });
                    this.provinceArr[this.provinceIndex].children[this.cityIndex].children[
                        this.areaIndex
                        ].children = json.data.map((item, index, arr) => {
                        item.value = item.id;
                        item.label = item.name;
                        return item;
                    });
                    resolve()
                };
                xhr.send();
            })
        },
        // 地理编码返回结果展示
        // handleGeocoder(data) {
        //     let geocode = data.geocodes[0];
        //     if (!this.companyInfo.lng || !this.companyInfo.lat) {
        //         this.addMarker([geocode.location.getLng(), geocode.location.getLat()]);
        //     }
        //     this.map.setFitView();
        // },
        // addMarker(position) {
        //     this.map.setCenter(position);
        //     this.marker && this.map.remove(this.marker);
        //     this.marker = new AMap.Marker({
        //         map: this.map,
        //         cursor: "move",
        //         draggable: true,
        //         position
        //     });
        //     this.companyInfo.lng = position[0];
        //     this.companyInfo.lat = position[1];
        //     let self = this;
        //     this.marker.on("mouseout", function(e) {
        //         self.companyInfo.lat = e.lnglat.lat;
        //         self.companyInfo.lng = e.lnglat.lng;
        //     });
        // },
        handleItemChange(val) {
            if (val.length == 1) {
                this.getCity(val[0])
            } else if (val.length == 2) {
                this.getArea(val[1])
            } else if (val.length == 3) {
                this.getStreet(val[2])
            }
        },
        updateAddress(result) {
            this.lng = result.location.lng;
            this.lat = result.location.lat;
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/company.less');

.com-model {
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// companyBase.vue?d5c0714e